import { render, staticRenderFns } from "./FoldingDirectionsScreen.vue?vue&type=template&id=7c74f781&scoped=true"
import script from "./FoldingDirectionsScreen.vue?vue&type=script&lang=js"
export * from "./FoldingDirectionsScreen.vue?vue&type=script&lang=js"
import style0 from "./FoldingDirectionsScreen.vue?vue&type=style&index=0&id=7c74f781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74f781",
  null
  
)

export default component.exports